/**
 * Drinking Water Microbiological Phase Constants
 * 
 * These constants define the available phases for drinking water microbiological examination
 * and their corresponding display labels in German.
 */

export interface MibiPhaseOption {
  id: string;
  name: string;
}

/**
 * Simple phase options for dropdowns
 */
export const DW_MIBI_PHASE_SIMPLE_OPTIONS: { id: string; name: string }[] = [
  { id: "OU", name: "orientierende Untersuchung" },
  { id: "WU", name: "weiterführende Untersuchung" },
  { id: "NU", name: "Nachuntersuchung" },
  { id: "NB", name: "Nachbeprobung" },
  { id: "EK", name: "Eigenkontrolle" }
];

export const NORMAL_MIBI_COMPLETION_OPTIONS: MibiPhaseOption[] = [
  { id:"3m" , name: "In 3 Monaten neu anlegen" },
  { id:"6m" , name: "In 6 Monaten neu anlegen" },
  { id:"end_task" , name: "Keine neuen Proben geplant" },
];

export const MIBI_COMPLETION_OPTIONS: { id: string; name: string }[] = [
  {
    id: "continue_ou_3y",
    name: "Mit orientierender Untersuchung weitermachen",
  },
  {
      id: "continue_wu",
      name: "Mit weiterführenden Untersuchung weitermachen",
  },
  {
      id: "continue_nu",
      name: "Mit Nachuntersuchung weitermachen",
  },
  {
      id: "continue_nb",
      name: "Mit Nach Beprobung weitermachen",
  },
  {
      id: "customer_control",
      name: "Kunde wird selber kontrolieren",
  },
];

export const ORDER_HANDLING_COMPLETION_OPTIONS: { id: string; name: string }[] = [
  {
    id: "continue_ou",
    name: "orientierende Untersuchung",
  },
  {
      id: "continue_wu",
      name: "Weiterführende Untersuchung",
  },
  {
      id: "continue_nu",
      name: "Nachuntersuchung",
  },
  {
      id: "continue_nb",
      name: "Nach Beprobung",
  },
  {
      id: "customer_control",
      name: "Fremdvergabe",
  },
];

// Sub-options for weiterführende Untersuchung
export const WU_TIMING_OPTIONS: { id: string; name: string }[] = [
  { id: "1m", name: "in einem Monat" },
];

// Sub-options for Nachuntersuchung and Nach Beprobung
export const NU_TIMING_OPTIONS: { id: string; name: string }[] = [
  { id: "2m", name: "in zwei Monaten (IN)" },
  { id: "3m", name: "in drei Monaten" },
  { id: "4m", name: "in vier Monaten (IN)" },
  { id: "5m", name: "in fünf Monaten (IN)" },
  { id: "6m", name: "in sechs Monaten" },
  { id: "1y", name: "in einem Jahr" },
];

// Sub-options for weiterführende Untersuchung
export const OU_TIMING_OPTIONS: { id: string; name: string }[] = [
  { id: "1y", name: "in einem Jahr" },
  { id: "3y", name: "in drei Jahren" },
];

export const TEST_PASSED_OPTIONS: { id: string; name: string }[] = [
  { id: "yes", name: "Ja" },
  { id: "no", name: "Nein" },
];